import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MediaWatcherHelperService } from '@app/core/services/media-watcher-helper.service';
import { layout } from '@app-styles/styles-contants';

@Component({
    selector: 'app-persona-picker',
    templateUrl: './persona-picker.component.html',
    styleUrls: ['./persona-picker.component.scss']
})
export class PersonaPickerComponent implements OnInit, OnDestroy, AfterViewInit {

    private destroy$ = new Subject<void>();

    isLarge$ = new BehaviorSubject<boolean>(true);

    handleIsLarge(matches) {
        this.isLarge$.next(matches);
    }

    constructor(
        private mediaWatcherHelper: MediaWatcherHelperService,
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewInit(): void {
        const { desktop: query } = layout;
        const callback = this.mediaWatcherHelper.buildWatcher(query, this.handleIsLarge.bind(this), this.cdr);
        this.mediaWatcherHelper.registerListener(callback, this.destroy$);
    }
}


